import type { TOC } from '@ember/component/template-only';
import type { ItemDetailsSignature } from './utils.gts';

/** Card details for books: author + overview */
const BookDetails: TOC<ItemDetailsSignature> = <template>
  {{#if (author @data)}}
    <p class="text-base-content/60 text-sm font-medium">
      {{author @data}}
    </p>
  {{/if}}
  {{#if (shouldShowOriginalTitle @item @data)}}
    <p class="text-base-content/50 text-xs italic">
      Original Title:
      {{originalTitle @data}}
    </p>
  {{/if}}
  {{#if (overview @data)}}
    <p
      class="text-base-content/70 mt-1 line-clamp-2 min-w-0 text-sm break-words"
    >
      {{overview @data}}
    </p>
  {{/if}}
</template>;

function author(data: Record<string, unknown> | null): string | null {
  if (!data) return null;
  const authors = data.authors as string[] | undefined;
  if (Array.isArray(authors) && authors.length > 0) return authors.join(', ');
  return (data.author as string) ?? null;
}

function originalTitle(data: Record<string, unknown> | null): string | null {
  if (!data) return null;
  return (data.originalTitle as string) ?? null;
}

function shouldShowOriginalTitle(
  item: ItemDetailsSignature['Args']['item'],
  data: Record<string, unknown> | null
): boolean {
  if (!data) return false;
  const orig = originalTitle(data);
  if (!orig) return false;

  // Get the display name from item
  const name = item.name as string;
  // Show original title if it differs from the item name
  return orig !== name;
}

function overview(data: Record<string, unknown> | null): string | null {
  return (data?.overview ?? data?.description) as string | null;
}

export default BookDetails;
